import Cookies from 'js-cookie';

export function getCsrfToken(): string {
  return Cookies.get('diveform_csrftoken') || '';
}
